<style scoped>
    @import url("../../../styles/smartControl/execView.scss");
</style>

<template>
    <div class="box_execView">

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <v-dialog v-model="flagDialog" max-width="250px">
            <div class="" v-if="flagDialog">
                <!-- O componente form -->
                <DialogExec v-if="flagDialog" :liDatas2conv2Date="liDatas2conv2Date" 
                @fromDialog="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <div v-if="!flagLoading && !flagZero" class="painelLiEl">

            <div class="mb-4">
                <v-chip class="ml-2" color="white">Últimas 48 horas</v-chip>
            </div>

            <div class="mb-4">
                <v-chip class="ml-2" color="#F39C12">{{ 'Período de segurança ' + minTimeExec + ' minutos' }}</v-chip>
            </div>
            
            <div v-for="(el,i) in liElExec" :key="i" class="elLi">

                <!-- CIRCLE STATUS -->
                <span class="el" v-if="el.status == 'init'"><v-icon :style="{'color':'yellow'}">mdi-circle</v-icon></span>
                <span class="el" v-else-if="el.status == 'pending'"><v-icon :style="{'color':'gray'}">mdi-circle</v-icon></span>
                <span class="el" v-else-if="el.status == 'start'"><v-icon :style="{'color':'blue'}">mdi-circle</v-icon></span>
                <span class="el" v-else-if="el.status == 'loss'"><v-icon :style="{'color':'red'}">mdi-circle</v-icon></span>
                <span class="el" v-else-if="el.status == 'ok'"><v-icon :style="{'color':'green'}">mdi-circle</v-icon></span>
                <span class="el" v-else><v-icon :style="{'color':'black'}">mdi-circle</v-icon></span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <!-- hh:mm (UTC - - -> LOCAL) -->
                <span class="el" :style="{'min-width':'45px'}">{{ el.local_dtstr_hr }}</span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <!-- STATUS -->
                <!--<span class="el" :style="{'min-width':'100px'}">{{ el.status }}</span>-->
                <span class="el_status" v-if="el.status == 'init'">Agendado</span>
                <span class="el_status" v-else-if="el.status == 'pending'">Aguardando</span>
                <span class="el_status" v-else-if="el.status == 'start'">Executando</span>
                <span class="el_status" v-else-if="el.status == 'loss'">Perdido</span>
                <span class="el_status" v-else-if="el.status == 'ok'">Concluído</span>
                <span class="el_status" v-else>Não identificado</span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <!-- TITULO ATUADOR -->
                <span v-if="el.tipo == 'ajuste_timeout'" class="el" :style="{'min-width':'160px','color':'#F39C12'}">AJUSTE</span>
                <span v-else class="el" :style="{'min-width':'160px'}">{{ el.titulo_atuador }}</span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <!-- SENTIDO DO COMANDO | v-if="Number.isInteger(el.tempo_segundos)" -->
                <span v-if="el.command_hex?.slice(0, 2) === '06' || el.command_hex?.slice(0, 2) === '10'"
                :style="{'min-width':'80px'}"
                class="el"
                >
                    {{ segundosParaHHMMSS(el.tempo_segundos) }}
                </span>
                <!--<span class="el" v-else :style="{'min-width':'100px'}">{{ el.flag }}</span>-->
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <!-- SENTIDO DO COMANDO -->
                <span class="el" :style="{'min-width':'80px'}" v-if="el.command_hex?.slice(0, 2) === '08' || el.command_hex?.slice(0, 2) === '0E'">Ligar</span>
                <span class="el" :style="{'min-width':'80px'}" v-if="el.command_hex?.slice(0, 2) === '09' || el.command_hex?.slice(0, 2) === '0F'">Desligar</span>

                <!-- ORIGEM DO COMANDO -->
                <span class="el" v-if="el.nota === 'act-main-by-ia'" :style="{'min-width':'100px'}">Agente IA</span>
                <span class="el" v-if="el.nota === 'auto-agend'" :style="{'min-width':'100px'}">Agente IA</span>
                <span class="el" v-if="el.nota === 'act-main' || el.nota === 'act-sub' || el.nota === 'realoc-from-act'" :style="{'min-width':'100px'}">Rompimento Limiar</span>
                <span class="el" v-if="el.nota === 'client-agend'" :style="{'min-width':'100px'}">Manual</span>
                <span class="el" v-if="el.nota === 'periodic-agend'" :style="{'min-width':'100px'}">Periodico</span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <!-- ICON EDITAR -->
                <span v-if="el.status == 'pending' || el.status == 'init'"
                class="el_icon" size="36" @click="cancelAgend(el)"><v-icon>mdi-close-circle</v-icon></span>

            </div>
        </div>

        <div v-if="liElExec.length==0 && !flagLoading && !flagZero">
            <span>Nenhum agendamento para esse dia.</span>
        </div>

        <div class="lineBtns" v-if="!flagLoading && flagZero">
            <span>Sem dados referente a um controlador</span>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
//import { convHhmmFromUtc } from "./timeUtils.js"; // função auxiliar local
//import { convHhmmFromUtc } from "../auxSC/handleTimeConv.js"; // 02/05/2026
import { convFromUtc } from "../auxSC/handleTimeConv.js"; // 17/06/2026
import DialogExec from './DialogExec.vue'

export default {

    components:{ DialogExec },

    props:['execSys', 'emailCliente'],

    data() {
        return {

            //
            flagLoading:true,
            flagZero:false,

            // -- dialog (seleção data bind v-model)
            flagDialog:false,
            liDatas2conv2Date:[], // -- lista de datas (dias) disponíveis para exib.

            // -- sistema do cliente rcv via props.
            sysSelected:'',

            //
            dateToday:'',
            liGeralTable:[], // -- lista com um dia em cada posição. 
            liElExec:[], // -- dia mais recente da lista geral de execução.
            minTimeExec:20, // default

            //
            timeoutDoDia:0, // registra o tempo de timeout para dia selecionado para exibição.
        }
    },

    methods:{

        cancelAgend(el) {
            console.log(el)

            this.flagLoading = true

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {
                'api_client':this.emailCliente,
                'sistema':this.sysSelected,
                'item':el
            }

            let url = self.$store.state.pathAxiosBASE + '/xcancelxagendxapi'

            let res = axios.post(url, params, {headers})
            console.log('[cancel] res: ',res)

            this.callInit()
        },

        segundosParaHHMMSS(totalSegundos) {

            let horas = Math.floor(totalSegundos / 3600);
            let minutos = Math.floor((totalSegundos % 3600) / 60);
            let segundos = totalSegundos % 60;

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;
        },
        
        async getLastAjusteTimeout() {

            this.flagLoading = true

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':this.emailCliente,'sistema':this.sysSelected}

            let url = self.$store.state.pathAxiosBASE + '/xgetxunid'

            let res = await axios.post(url, params, {headers})

            console.log(res.data.result)

            const el_command = res.data?.result

            if (!el_command) {
                return null
            }
            
            const last_ajuste_timeout = el_command['last_ajuste_timeout'] // dict
            const segundos = last_ajuste_timeout['comando_segundos'] // int str
            //console.log('[getLastAjusteTimeout] segundos: ',segundos)
            return segundos
        },

        async callInit() {

            this.flagLoading = true

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':this.emailCliente, 'sistema':this.sysSelected, 'marcador':'all'}

            let url = self.$store.state.pathAxiosBASE + '/getagend'
            let res = await axios.post(url, params, {headers})

            // -- obter PERIODO DE SEGURANÇA entre agendamentos.
            const el_agend = res.data.result
            let exec_period = el_agend['periodo_exec'] // string or int
            self.minTimeExec = parseInt(exec_period) // garantir inteiro

            // -- obter fila agend associada ao sistema.
            params = { 'api_client':this.emailCliente, 'sistema':this.sysSelected }
            url = self.$store.state.pathAxiosBASE + '/xgetxagendxapi'
            let res_b = await axios.post(url, params, {headers})
            const liAgend72h = res_b.data.result // list invertida (o item mais recente é [0])
            //console.log('[ExecExibView] liAgend72h[0]:',liAgend72h[0])
            this.liElExec = liAgend72h

            if (liAgend72h.length > 0) {

                //console.log('liAgend72h[0]: ',liAgend72h[0])
                this.liElExec = liAgend72h

                // -- remover os cancelados.
                this.liElExec = this.liElExec.filter(el => el.status !== 'cancelled')

                // -- criar key local_dtstr_hr
                // convFromUtc(dtUtcIso, tzName = "Europe/Lisbon")
                const tzName = this.$store.state.fusoHorarioSC // esperado --> "Europe/Lisbon"
                for (let i = 0; i < this.liElExec.length; i++) {

                    const localInfo = convFromUtc(
                        this.liElExec[i].utc_trigger,
                        tzName
                    )

                    this.liElExec[i].local_dtstr_hr =
                        `${localInfo.dataStr}-${localInfo.hhmm}`
                }
            }
            else {

                console.log('[ExecExibView] lista vazia')
            }

            // -- obter timeout atualmente configurado
            const segundos_config = this.getLastAjusteTimeout()
            console.log('segundos_config: ',segundos_config)

            this.flagLoading = false
        },
    },

    created() {
        window.scrollTo(0,0)

        this.sysSelected = this.execSys
        //console.log('[ExecTable] execSys -> sys_selected: ',this.sysSelected)
        //console.log('[ExecTable] emailCliente: ',this.emailCliente)

        this.callInit()
    }
}
</script>